import VueRouter from "vue-router";
import Vue from "vue";
import store from "@/store";
import { getToken, whiteList, removeToken } from "@/utils/auth";
import Layout from "/src/layout/index.vue";
import { getMaintenanceDetails } from "@/services/form";
Vue.use(VueRouter);

let _maintenanceCache = null;
export function resetMaintenanceCache() {
  _maintenanceCache = null;
}
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      component: () => import("/src/view/login"),
    },
    {
      path: "/mvpLogin",
      component: () => import("/src/view/mvp-login"),
    },
    {
      path:'/loginByCode',
      component: () => import("/src/view/mvp-login2"),
    },
    {
      path: "/activate",
      component: () => import("/src/view/activate"),
    },
    {
      path: "/register",
      component: () => import("/src/view/register"),
    },
    {
      path: "/404",
      component: () => import("/src/view/error/404"),
    },
    {
      path: "/mvp/authentication",
      component: () => import("/src/view/mvp-authentication"),
    },
    {
      path: "/pilot",
      component: Layout,
      children: [
        {
          path: "index",
          component: () => import("@/view/pilot/index.vue"),
        },
      ],
    },
  ],
});
router.beforeEach(async (to, _from, next) => {
  const token = getToken();
  if (token) {
    if (!store.state.userInfo) {
      await store.dispatch("getUserInfo");
      return next({ ...to, replace: true });
    }

    if (to.path !== '/login') {
      try {
        const res = await getMaintenanceDetails();
        _maintenanceCache = res?.data ?? {};
      } catch (e) {
        _maintenanceCache = {};
      }
    }

    if (_maintenanceCache?.isUnderMaintenance) {
      const ui = store.state.userInfo;
      const isAdmin = ui?.userType == 0;
      if (!isAdmin) {
        _maintenanceCache = null;
        removeToken();
        Vue.prototype.$message?.closeAll?.();
        return next('/login?maintenance=1');
      }
    }

    next();
  } else {
    _maintenanceCache = null;
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
    }
  }
});

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
export default router;
